import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { MenuEffects } from './menu.effects';
import { reducer } from './menu.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('menu', reducer),
    EffectsModule.forFeature([MenuEffects]),
  ],
  providers: [MenuEffects],
})
export class MenuStoreModule {}
